// 指定の要素にactiveフラグを付けたり外したりするスクリプト
// [data-**-to="{HTMLのID}"]で指定されたIDを持つ要素と自身と同じボタンの要素に[data-active="{true|false}"]を付与する

const bulkUpdate = (targetID, active) => {
  const selector = `
  [data-activate-to="${targetID}"],
  [data-deactivate-to="${targetID}"],
  [data-activate-toggle-to="${targetID}"]
  `;
  document.querySelectorAll(selector).forEach((target) => {
    target.dataset['active'] = active;
  });
};

export const bindClickEvents = () => {
  document.querySelectorAll('[data-activate-to]').forEach((button) => {
    const targetID = button.dataset['activateTo'];
    const target = document.getElementById(targetID);
    if(!target){
      return;
    }
    button.addEventListener('click', () => {
      bulkUpdate(targetID, 'true');
      target.dataset['active'] = 'true';
    });
  });

  document.querySelectorAll('[data-deactivate-to]').forEach((button) => {
    const targetID = button.dataset['deactivateTo'];
    const target = document.getElementById(targetID);
    if(!target){
      return;
    }
    button.addEventListener('click', () => {
      bulkUpdate(targetID, 'false');
      target.dataset['active'] = 'false';
    });
  });

  document.querySelectorAll('[data-activate-toggle-to]').forEach((button) => {
    const targetID = button.dataset['activateToggleTo'];
    const target = document.getElementById(targetID);
    if(!target){
      return;
    }
    button.addEventListener('click', () => {
      const isActivated = target.dataset['active'] === 'true';
      bulkUpdate(targetID, String(!isActivated));
      target.dataset['active'] = String(!isActivated);
    });
  });
};
